"use client";

import Image from "next/image";
import { motion } from "framer-motion";
import { useRef } from "react";
import { useInViewAnimation } from "../animation/useInViewAnimation";
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";

const ScrollFloat = dynamic(() => import("./animations/ScrollFloat"), {
  ssr: false,
});

export default function WerWirSind() {
  const ref = useRef(null);
  const inView = useInViewAnimation(ref);
  const { t } = useTranslation("werwirsind");

  return (
    <div
      ref={ref}
      className="relative w-screen h-auto md:min-h-[40rem] lg:h-[100vh] overflow-hidden text-[#262104] md:py-10 mt-10 md:my-0"
    >
      <Image
        src="/img/wer_35.png"
        alt="WerWirSind"
        fill
        className="hidden md:block object-cover z-0"
        priority
      />

      <div className="md:hidden w-full">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className=" rounded-md overflow-hidden w-full max-w-[680px] mx-auto"
        >
          <div className="relative w-full">
            <Image
              src="/img/wer_mobile.JPG"
              alt="WerWirSind mobile"
              width={1200}
              height={800}
              className="w-full h-auto object-contain"
              priority
            />
          </div>

          <div className="px-4 pt-6 text-center">
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="mb-4"
            >
              <ScrollFloat
                animationDuration={1}
                ease="back.inOut(2)"
                scrollStart="center bottom+=50%"
                scrollEnd="bottom bottom-=40%"
                stagger={0.03}
                containerClassName="inline-block"
                textClassName="text-3xl sm:text-3xl font-semibold tracking-tight font-[futura]"
              >
                {t("wersindwir")}
              </ScrollFloat>
            </motion.h1>
          </div>

          {/* Текст */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="px-4 pb-6 text-base sm:text-lg leading-6 font-[futura] text-center"
          >
            <p>
              {t("paragraph1")}{" "}
              <b>
                REEFLI
                <span className="align-super text-[0.65em] font-sans ml-0.5">
                  ™
                </span>
              </b>
              :<br />
              <br />
              <i>{t("paragraph1_1")}</i>
            </p>

            <div className="mt-4">
              <p>{t("paragraph2")}</p>
            </div>
          </motion.div>
        </motion.div>
      </div>

      <div className="relative z-10 w-full h-full hidden md:flex px-6 md:px-12">
        <div className="w-1/2" />
        <div className="w-1/2 flex flex-col justify-center items-start space-y-8 xl:space-y-12 max-w-2xl text-lg md:text-xl leading-8 font-medium tracking-wide font-[futura]">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
          >
            <p>
              {t("paragraph1")}{" "}
              <b>
                REEFLI
                <span className="align-super text-[0.65em] font-sans ml-0.5">
                  ™
                </span>
              </b>
              :<br />
              <br />
              <i>{t("paragraph1_1")}</i>
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <p>{t("paragraph2")}</p>
          </motion.div>
        </div>
      </div>
    </div>
  );
}
